(() => {
  const KEY = 'cb_favorites_v1';
  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.8 4.7a5.5 5.5 0 0 0-7.8 0L12 5.8l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.5a5.5 5.5 0 0 0 0-7.8Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const safeHandle = value => /^[a-z0-9][a-z0-9-]*$/.test(value || '');
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(KEY) || '{}');
      return data && typeof data === 'object' && !Array.isArray(data) ? data : {};
    } catch (_) { return {}; }
  };
  const write = data => {
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (_) { return false; }
    update();
    return true;
  };
  const productUrl = handle => '/products/' + encodeURIComponent(handle);
  const productData = async handle => {
    const response = await fetch(productUrl(handle) + '.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Product unavailable');
    const p = await response.json();
    return { handle, title: p.title || handle, image: p.featured_image || (p.images && p.images[0]) || '', price: Number(p.price) || 0 };
  };
  const money = cents => new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', maximumFractionDigits: 0 }).format((Number(cents) || 0) / 100);
  const toggle = async (button, handle) => {
    const list = read();
    if (list[handle]) {
      delete list[handle];
      write(list);
      return;
    }
    button.disabled = true;
    try {
      list[handle] = await productData(handle);
      if (!write(list)) throw new Error('Storage unavailable');
    } catch (_) {
      button.setAttribute('aria-label', 'Kunde inte spara favorit');
    } finally { button.disabled = false; }
  };
  const addButton = (target, handle, mode) => {
    if (!safeHandle(handle) || target.querySelector(':scope > .cb-favorite-toggle')) return false;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'cb-favorite-toggle cb-favorite-toggle--' + mode;
    button.dataset.favoriteHandle = handle;
    button.innerHTML = heart;
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      toggle(button, handle);
    });
    target.append(button);
    return true;
  };
  const enhance = () => {
    let added = false;
    document.querySelectorAll('.product-card[data-product], .card-extended-wrapper[data-product]').forEach(card => {
      const handle = card.getAttribute('data-product');
      const target = card.querySelector('.card__inner, .card-extended__inner') || card;
      added = addButton(target, handle, 'card') || added;
    });
    const path = location.pathname.match(/^\/products\/([a-z0-9-]+)/);
    if (path) {
      const gallery = document.querySelector('.product__media-list-wrapper');
      if (gallery) added = addButton(gallery, path[1], 'product') || added;
    }
    if (added) update();
  };
  const renderPage = list => {
    const grid = document.getElementById('cb-favorites-grid');
    if (!grid) return;
    grid.replaceChildren();
    const items = Object.values(list).filter(item => item && safeHandle(item.handle));
    const empty = document.getElementById('cb-favorites-empty');
    if (empty) empty.hidden = items.length > 0;
    items.forEach(item => {
      const article = document.createElement('article');
      article.className = 'cb-favorite-card';
      const link = document.createElement('a');
      link.href = productUrl(item.handle);
      link.className = 'cb-favorite-card__link';
      if (item.image && /^(https?:)?\/\//.test(item.image)) {
        const img = document.createElement('img');
        img.src = item.image.startsWith('//') ? 'https:' + item.image : item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        link.append(img);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'cb-favorite-card__placeholder';
        placeholder.textContent = 'Din egen bild';
        link.append(placeholder);
      }
      const title = document.createElement('h2');
      title.textContent = item.title || item.handle;
      link.append(title);
      article.append(link);
      if (item.price) {
        const price = document.createElement('p');
        price.textContent = money(item.price);
        article.append(price);
      }
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cb-favorite-remove';
      remove.textContent = 'Ta bort från favoriter';
      remove.addEventListener('click', () => {
        const next = read();
        delete next[item.handle];
        write(next);
      });
      article.append(remove);
      grid.append(article);
    });
  };
  function update() {
    const list = read();
    document.querySelectorAll('.cb-favorite-toggle').forEach(button => {
      const active = !!list[button.dataset.favoriteHandle];
      button.classList.toggle('is-favorite', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Ta bort från favoriter' : 'Lägg till i favoriter');
    });
    const count = document.querySelector('.cb-favorites-count');
    if (count) {
      const length = Object.keys(list).length;
      count.textContent = String(length);
      count.hidden = length === 0;
    }
    renderPage(list);
  }
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; enhance(); });
  });
  document.addEventListener('DOMContentLoaded', () => {
    enhance();
    update();
    observer.observe(document.body, { childList: true, subtree: true });
  });
  window.addEventListener('storage', event => { if (event.key === KEY) update(); });
})();
